// Version : 0.0.1
// Author : AGALYA
// LastEdit : KARTHEESWARAN
// MODFIED DATE:01-08-2025
const FunderActionTypes = {
	/** ***************** ADD FUNDER DETAILS START *********************** */
	ADD_FUNDER_START: 'add_funder_start',
	ADD_FUNDER_SUCCESS: 'add_funder_success',
	ADD_FUNDER_FAILURE: 'add_funder_failure',
	ADD_FUNDER_RESPONSE_RESET: 'add_funder_response_reset',
	ADD_FUNDER_RESPONSE_CHANGED: 'add_funder_response_changed',
	/** ***************** ADD FUNDER DETAILS END *********************** */

	/** ***************** GET FUNDER LIST START *********************** */
	GET_FUNDER_LIST_START: 'get_funder_list_start',
	GET_FUNDER_LIST_SUCCESS: 'get_funder_list_success',
	GET_FUNDER_LIST_FAILURE: 'get_funder_list_failure',
	GET_FUNDER_LIST_RESPONSE_RESET: 'get_funder_list_response_reset',
	GET_FUNDER_LIST_RESPONSE_CHANGED: 'get_funder_list_response_changed',
	/** ***************** GET FUNDER LIST END *********************** */

	/** ***************** UPDATE FUNDER DETAILS START *********************** */
	UPDATE_FUNDER_START: 'update_funder_start',
	UPDATE_FUNDER_SUCCESS: 'update_funder_success',
	UPDATE_FUNDER_FAILURE: 'update_funder_failure',
	UPDATE_FUNDER_RESPONSE_RESET: 'update_funder_response_reset',
	UPDATE_FUNDER_RESPONSE_CHANGED: 'update_funder_response_changed',
	/** ***************** UPDATE FUNDER DETAILS END *********************** */

	/** ***************** FETCH FUNDER DETAILS START *********************** */
	FETCH_FUNDER_START: 'fetch_funder_start',
	FETCH_FUNDER_SUCCESS: 'fetch_funder_success',
	FETCH_FUNDER_FAILURE: 'fetch_funder_failure',
	FETCH_FUNDER_RESPONSE_RESET: 'fetch_funder_response_reset',
	FETCH_FUNDER_RESPONSE_CHANGED: 'fetch_funder_response_changed',
	/** ***************** FETCH FUNDER DETAILS END *********************** */

	/** ***************** DELETE FUNDER DETAILS START *********************** */
	DELETE_FUNDER_START: 'delete_funder_start',
	DELETE_FUNDER_SUCCESS: 'delete_funder_success',
	DELETE_FUNDER_FAILURE: 'delete_funder_failure',
	DELETE_FUNDER_RESPONSE_RESET: 'delete_funder_response_reset',
	DELETE_FUNDER_RESPONSE_CHANGED: 'delete_funder_response_changed',
	/** ***************** DELETE FUNDER DETAILS END *********************** */

	/** ***************** UPDATE FUND PUBLISH STATUS START *********************** */
	UPDATE_ISPUBLISH_FUNDER_START: 'update_isPublish_Funder_start',
	UPDATE_ISPUBLISH_FUNDER_SUCCESS: 'update_isPublish_Funder_success',
	UPDATE_ISPUBLISH_FUNDER_FAILURE: 'update_isPublish_Funder_failure',
	UPDATE_ISPUBLISH_FUNDER_RESPONSE_RESET: 'update_isPublish_Funder_response_reset',
	UPDATE_ISPUBLISH_FUNDER_RESPONSE_CHANGED: 'update_isPublish_Funder_response_changed',
	/** ***************** UPDATE FUND PUBLISH STATUS END *********************** */
};
export default FunderActionTypes;
